module.exports = __webpack_public_path__ + "static/fakenews-06e6fb2b1f4183af5aa7340095627713.jpg";